import { Component } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import './App.scss';
import DashboardHomeClann from './pages/Dashboard/Dashboard';
import { Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './pages/homepage/Homepage';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { initialize } from './utils/axiosInstances';
import { initKeycloak } from './utils/keycloak';

const THEME = createTheme({
  typography: {
    fontFamily: `'Quicksand', sans-serif`,
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keycloak: null,
      searchURL: null,
      savatarURL: null,
      authenticated: false,
      userInfo: null,
      isAdmin: null,
      preferredTools: [],
    };
  }

  async componentDidMount() {
    try {
      // Load the environment data
      const environment = (await axios.get('/config/environment.json', { baseURL: '' })).data;

      // Setup the keycloak data
      const keycloak = initKeycloak(environment.keycloak);
      const authenticated = await keycloak.init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        // keycloak-js 26 enables PKCE (S256) by default. Keep it on everywhere
        // except environments explicitly flagged as legacy: the Keycloak 9 server
        // still running in production rejects PKCE, surfacing as a CORS error on
        // login. Legacy environments opt in via `keycloak.legacy: true` in their
        // environment.json. TODO: drop this flag (and force S256) once the
        // production Keycloak is upgraded past v9.
        pkceMethod: environment.keycloak?.legacy ? false : 'S256',
      });

      await initialize(keycloak.token);

      const searchURL = environment.searchUrl;
      const savatarURL = environment.savatarUrl;
      const SRAMUrl = environment.SRAMUrl;

      // Load the keycloak user details
      const userInfo = await keycloak.loadUserInfo();
      // If is an external user, redirect to SRAM
      if (userInfo.email.includes('external')) {
        window.location.replace(SRAMUrl);
      }
      // Trigger the highlands user sync and set if it is admin
      const isAdmin = userInfo?.groups?.includes('highlands-admins');

      // Set the state and start the application
      this.setState({
        keycloak,
        authenticated,
        userInfo,
        searchURL,
        savatarURL,
        isAdmin,
      });
    } catch (error) {
      this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
    }
  }

  render() {
    if (this.state.keycloak) {
      if (this.state.authenticated)
        {return (
          <MuiThemeProvider theme={THEME}>
            <Routes>
              <Route
                path="/"
                element={
                  <Homepage
                    userInfo={this.state.userInfo}
                    keycloak={this.state.keycloak}
                    isAdmin={this.state.isAdmin}
                    searchURL={this.state.searchURL}
                    savatarURL={this.state.savatarURL}
                  />
                }
              />
              {this.state.isAdmin && (
                <Route
                  path="/dashboard/*"
                  element={
                    <DashboardHomeClann
                      keycloak={this.state.keycloak}
                      savatarURL={this.state.savatarURL}
                    />
                  }
                />
              )}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MuiThemeProvider>
        );}
      else {return <div>Unable to authenticate!</div>;}
    }
    return <div></div>;
  }
}

// notistack v3 removed the `withSnackbar` HOC; wrap App manually so the existing
// class component can keep receiving `enqueueSnackbar`/`closeSnackbar` as props.
const AppWithSnackbar = (props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return <App {...props} enqueueSnackbar={enqueueSnackbar} closeSnackbar={closeSnackbar} />;
};

export default AppWithSnackbar;
